@if (!disableOutsideClick) {
<div
  atxClickOutside
  (clickOutside)="clearCopyActiveRow(); clearActiveGridCell()"
  class="grid-container"
>
  <ng-container [ngTemplateOutlet]="gridContent"></ng-container>
</div>
} @else {
<div class="grid-container">
  <ng-container [ngTemplateOutlet]="gridContent"></ng-container>
</div>
}

<ng-template #gridContent>
  <div
    class="grid-row grid-header"
    [ngClass]="{ 'grid-sticky': !readonly }"
    [style.grid-template-columns]="gridColumnsStyle | safeStyle"
  >
    <span
      class="pl-4 color-col"
      i18n="Size grid|Size grid header text for Color@@sizeGridColor"
    >
      Color
    </span>
    <div
      class="d-grid x-size-row p-0"
      [style.grid-template-columns]="subGridColumnsStyle | safeStyle"
      [style.grid-column-end]="subGridColumnEnd | safeStyle"
    >
      @for (size of xSizes; track index; let index = $index) {
      <span
        class="x-size"
        [class.active]="isColumnActive(index)"
        data-e2e="xSize"
        >{{ size }}</span
      >
      }
    </div>
    @if (showTotals) {
    <span class="color-col scale-selector-cell">
      @if (scaleSelectorVisible) {
      <epc-scale-selector
        class="flex-shrink-0 my-0 mx-auto"
        [scales]="scaleSets"
        [selected]="selectedScale"
        [scaleDisplayObject]="scaleDisplayObject"
        [disabled]="isScaleSelectorDisabled"
        (selectScale)="handleScaleSelection($event)"
      ></epc-scale-selector>
      }
    </span>
    }
  </div>

  @if (sizerunsGrid) {
  <div
    class="grid-row grid-size-runs-header"
    [ngClass]="{ 'grid-sticky': !readonly }"
    [style.grid-template-columns]="gridColumnsStyle | safeStyle"
  >
    <span
      class="pl-4 color-col"
      i18n="Size grid|Size grid size-runs header text@@sizeGridSizeRuns"
    >
      Predefined quantities per size
      <fa-icon
        class="ml-1"
        [icon]="['fas', 'circle-question']"
        atxTooltip="For this style you can add only predefined quantities"
        i18n-atxTooltip="
          Size grid|Size runs with predefined quantities tooltip
          message@@sizeRunsPredefinedQuantitiesTooltip"
      ></fa-icon>
    </span>
    <div
      class="d-grid size-runs-row p-0"
      [style.grid-template-columns]="subGridColumnsStyle | safeStyle"
      [style.grid-column-end]="subGridColumnEnd | safeStyle"
    >
      @for (size of xSizes; track trackByIndex(index, size); let index = $index)
      {
      <span
        class="size-runs-row-value"
        [class.active]="isColumnActive(index)"
        >{{ sizeRunsSizes[index] ? sizeRunsSizes[index] : '' }}</span
      >
      }
    </div>
    @if (showTotals) {
    <span class="color-col border-0"> </span>
    }
  </div>
  }

  <div class="grid-body" #gridBody cdkDropListGroup>
    @for ( material of materials; track trackByProductId(materialIndex,
    material); let materialIndex = $index) {
    <div
      class="grid-row product-grid"
      [formGroup]="formGroup"
      [style.grid-template-columns]="gridColumnsStyle | safeStyle"
      [class.highlight-row]="
        highlightRow === material.productId ||
        masterQuantitiesPrefillProductId === material.productId
      "
      [attr.data-e2e]="'size-grid-row-' + material.productId"
    >
      <!-- color column -->
      <div
        class="size-grid-material-title color-col py-0"
        [style.grid-column]="
          disabledMaterialsIds && disabledMaterialsIds[material.productId]
            ? 'span ' + (xSizes?.length + 2)
            : ''
        "
        [style.width]="
          disabledMaterialsIds && disabledMaterialsIds[material?.productId]
            ? element.nativeElement.offsetWidth + 'px'
            : ''
        "
        [class.active]="activeCell?.materialId === material?.productId"
        [class.disabled]="
          disabledMaterialsIds && disabledMaterialsIds[material?.productId]
        "
        [class.highlight-row]="
          highlightRow === material.productId ||
          masterQuantitiesPrefillProductId === material.productId
        "
        (click)="onMaterialClick(material.productId)"
        data-e2e="size-grid-material-title"
      >
        @if (isNowOrder && isRowHasConsignment(material.productId)) {
        <div class="position-relative bulk-label-holder h-100">
          <div
            class="bg-bulk color-bulk d-flex align-items-center position-absolute h-100 w-100 overflow-hidden"
          >
            <span
              i18n="Size Grid|Bulk label@@bulkIndicatorLabel"
              class="text-uppercase size-grid-bulk"
            >
              Bulk
            </span>
          </div>
        </div>
        } @if (isCopyPrefilledVisible) {
        <epc-copy-quantities
          class="d-flex pl-2"
          [isDefault]="masterQuantitiesPrefillProductId === material.productId"
        ></epc-copy-quantities>
        }
        <div
          class="product w-100 align-items-center"
          [class.padding-for-noos]="material.neverOutOfStockType"
        >
          @if ((componentStore.markVariantInOpenedList$ | async) &&
          componentStore.isListPage()) { @if
          (componentStore.isMaterialInOpenedList(material.productId,
          (componentStore.openedListProductReferences$ | async))) {
          <fa-icon
            class="list-icon text-dark"
            [icon]="['fas', 'tag']"
            [atxTooltip]="variantInOpenedListLocale"
          ></fa-icon>
          } @else {
          <fa-icon
            class="list-icon invisible"
            [icon]="['fas', 'tag']"
          ></fa-icon>
          } }
          <div
            class="d-flex align-items-center flex-grow-1 position-relative pl-md-3 pl-0"
          >
            <div class="position-relative">
              <atx-product-image
                class="img-fluid"
                [class.img-inactive]="highlightRow === material.productId"
                [imageUrl]="material.mainImageUrl"
                [maxWidth]="imageMaxSizes.AVATAR"
                (click)="clickMaterialImage(material.productId)"
                data-e2e="row-image"
                [product]="material"
                [productImageMissingVisualConfig]="
                  productImageMissingVisualConfig
                "
              ></atx-product-image>
              @if (material.neverOutOfStockType) {
              <epc-never-out-of-stock-icon
                [iconSize]="NeverOutOfStockIconSize.SMALL"
                [type]="material.neverOutOfStockType"
              ></epc-never-out-of-stock-icon>
              }
            </div>
            <div class="flex-grow-1 align-items-center product-info-holder">
              <span
                data-e2e="material-title-container"
                class="flex-grow-1 d-flex flex-row align-items-center"
              >
                @if (editCustomerProductIdentifierEnabled) {
                <fa-icon
                  [atxPopover]="customerProductIdentifierTemplate"
                  autoClose="outside"
                  (atxPopoverClose)="
                    updateCustomerProductIdentifier(
                      material.productId,
                      material.brandId
                    )
                  "
                  #popoverInstance="atxPopover"
                  (atxPopoverOpen)="
                    onCustomerProductIdentifierPopoverOpen(
                      popoverInstance,
                      material.productId
                    )
                  "
                  class="mr-1"
                  [icon]="['fas', 'file-plus']"
                ></fa-icon>
                }
                <span class="d-flex flex-column flex-1 flex-grow-1 pr-1">
                  <epc-product-title
                    [title]="getMaterialTitle(material)"
                    [canShowCopyMessage]="
                      isCopyPrefilledVisible &&
                      hasRowQuantities(rowTotals()[material.productId]) &&
                      masterQuantitiesPrefillProductId !== material.productId
                    "
                    (highlight)="
                      $event === true
                        ? (highlightRow = material.productId)
                        : (highlightRow = -1)
                    "
                    (copyQuantities)="onMasterQuantitiesPrefill(material)"
                  ></epc-product-title>
                  @if ( getCustomerProductIdentifier( material.productId ); as
                  customerProductIdentifier ) {
                  <span class="text-muted font-italic">
                    {{ customerProductIdentifier }}
                  </span>
                  }
                </span>
                @if ( disabledMaterialsIds &&
                disabledMaterialsIds[material.productId]; as disabledData ) {
                <div class="d-flex">
                  @if ( getInboundQuantity( material.productId ); as
                  inboundQuantity ) {
                  <atx-badge
                    [icon]="['fas', 'truck']"
                    [title]="inboundTitle"
                    (mouseenter)="
                      toggleInboundQuantity(material.productId, true)
                    "
                    (mouseleave)="
                      toggleInboundQuantity(material.productId, false)
                    "
                    class="inbound-badge-disabled-line"
                    >{{ inboundQuantity }}</atx-badge
                  >
                  }
                  <div
                    [style.max-width]="subGridUnavailableMsgSize | safeStyle"
                    class="unavailable disabled ml-3 justify-content-end"
                  >
                    <span
                      class="mr-3"
                      i18n="
                        Size Grid|Unavailable material
                        label@@unavailableMaterialLabel"
                      >This color is unavailable for selected date
                    </span>
                    @if (showNextAvailableDate) {
                    <div
                      class="d-flex align-items-center flex-column flex-sm-row"
                    >
                      @if (disabledData.future) {
                      <ng-container
                        i18n="
                          Size Grid|Next available date
                          label@@nextAvailableDateLabel"
                      >
                        Next available date:
                      </ng-container>
                      @if (disabledData.future) {
                      <button
                        class="btn py-0 pl-1 d-flex"
                        (click)="selectPeriod(disabledData.future)"
                      >
                        <epc-delivery-period-date-label
                          [intervalType]="deliveryWindowType"
                          [deliveryData]="disabledData.future"
                        ></epc-delivery-period-date-label>
                      </button>
                      } } @if (disabledData.hasNow && !disabledData.future) {
                      <button
                        class="btn py-0 pl-1"
                        (click)="selectNow()"
                        i18n="
                          Size Grid|Next available now
                          label@@nextAvailableNowLabel"
                      >
                        Switch to Now
                      </button>
                      }
                    </div>
                    }
                  </div>
                </div>
                }
                <ng-template #customerProductIdentifierTemplate>
                  <span class="d-flex">
                    <input
                      [maxlength]="MAX_CUSTOMER_PRODUCT_IDENTIFIER_LENGTH"
                      class="m-2 form-control"
                      [formControl]="customerProductIdentifierFormControl"
                      i18n-placeholder="
                        Size Grid|placeholder in the input for customer products
                        numbers@@customerProductIdentifierInputPlaceholder"
                      placeholder="Custom Product #"
                      #customerProductIdentifierInput
                    />
                  </span>
                </ng-template>
              </span>
              @if (getMaterialDiscount(material.productId); as discount) { @if
              ((discount?.max || 0) > 0) {
              <atx-discount-label
                *atxCanShowByWsp
                [discount]="discount"
                class="d-flex align-items-center justify-content-center text-success mr-1"
              ></atx-discount-label>
              } } @if (isNowOrder && hasFastDelivery(material.productId)) {
              <atx-badge
                [icon]="['fas', 'truck-fast']"
                atxTooltip="Fast delivery"
                i18n-atxTooltip="
                  Size grid|Fast delivery tooltip message@@fastDeliveryTooltip"
              >
              </atx-badge>
              } @if ( getInboundQuantity(material.productId); as inboundQuantity
              ) {
              <atx-badge
                class="inbound-badge"
                [icon]="['fas', 'truck']"
                [title]="inboundTitle"
                (mouseenter)="toggleInboundQuantity(material.productId, true)"
                (mouseleave)="toggleInboundQuantity(material.productId, false)"
                (click)="openInboundDetails()"
                >{{ inboundQuantity }}</atx-badge
              >
              } @if (material.isLocked && !readonly) {
              <atx-badge
                [class.locked]="material.isLocked"
                [icon]="['fas', 'lock']"
                [title]="lockedTitle"
                atxTooltip="To order loose sizes, you must first purchase the starter pack."
                i18n-atxTooltip="
                  Size grid|Starter pack tooltip message@@starterPackTooltip"
              ></atx-badge>
              }
            </div>
            @if (!ySizes) {
            <ng-container
              [ngTemplateOutlet]="sizeRunAction"
              [ngTemplateOutletContext]="{
                material: material,
                row: 0,
                hasPadding: true
              }"
            >
            </ng-container>
            } @if (sizerunsGrid) {
            <div class="position-relative d-flex align-items-center">
              @if ( !disabledMaterialsIds ||
              !disabledMaterialsIds[material.productId] ) {
              <epc-size-runs-quantities
                class="mr-3"
                [quantity]="getSizeRunsQuantity(material.productId)"
                [maxQuantity]="getSizeRunsQuantitiesMax(material.productId)"
                (quantityChange)="
                  onSizeRunsQuantityChange(material.productId, $event)
                "
              ></epc-size-runs-quantities>
              } @if ( sizerunsGrid && hasSomeNotFulfilled(material.productId, 0)
              ) {
              <fa-icon
                class="not-full-size-run ml-1"
                [icon]="['fas', 'triangle-exclamation']"
                size="sm"
                atxTooltip="Some quantities were not available"
                i18n-atxTooltip="
                  Size grid|Size runs some quantities were not available tooltip
                  message@@sizeRunsSomeQuantitiesNotAvailableTooltip"
              ></fa-icon>
              }
            </div>
            }
          </div>
        </div>
        <div *ngIf="componentStore.showSizeGridBookmarkButton$ | async">
          <atx-bookmark-button
            [showAddBookmarkButton]="
              componentStore.notAddedToActiveList(material) | async
            "
            (click)="componentStore.patchActiveProductList(material)"
            class="pl-0 pr-2"
          >
          </atx-bookmark-button>
        </div>
        <div class="d-grid y-sizes">
          @for ( ySize of ySizes; track trackByIndex(row, ySize); let row =
          $index) {
          <span
            class="y-size"
            [class.active]="isRowActive(material.productId, row)"
            [class.d-none]="getRowInventorySum(material.productId, row) === 0"
            >{{ ySize || '&nbsp;' }}
            <ng-container
              [ngTemplateOutlet]="sizeRunAction"
              [ngTemplateOutletContext]="{ material: material, row: row }"
            >
            </ng-container>
          </span>
          }
        </div>
      </div>
      <!-- quantities -->
      <div
        class="d-grid py-0 quantities"
        [style.grid-template-columns]="subGridColumnsStyle | safeStyle"
        [style.grid-column-end]="subGridColumnEnd | safeStyle"
      >
        <!-- This layer required to have the crosshair effect in the grid -->
        @for ( rowGroup of formGroup.get(material.productId)?.controls; track
        row; let row = $index) {
        <div
          class="grid-row cells"
          navRow
          [class.d-none]="getRowInventorySum(material.productId, row) === 0"
          [style.grid-template-rows]="subGridRowsStyle | safeStyle"
          [style.grid-template-columns]="subGridColumnsStyle | safeStyle"
          [style.grid-column-end]="subGridColumnEnd | safeStyle"
          [formGroup]="rowGroup"
          inline="end"
          (mouseover)="hoverRow(material.productId, row, true)"
          (mouseleave)="hoverRow(material.productId, row, false)"
        >
          @for ( quantitiesGroup of rowGroup.controls; track column; let column
          = $index) { @if ({ inventoryObj: getCellInventories( materialsMatrix,
          sizesInventories)(material.productId, row, column) }; as cellData) {
          <epc-grid-cell
            [ngClass]="{
              top:
                materialIndex === displayCopyCoords.start.y &&
                row === displayCopyCoords.start.subY,
              left: column === displayCopyCoords.start.x,
              right: column === displayCopyCoords.end.x,
              bottom:
                materialIndex === displayCopyCoords.end.y &&
                row === displayCopyCoords.end.subY
            }"
            cdkDropList
            (cdkDropListEntered)="setCopyEndCoords(column, materialIndex, row)"
            [inBasketQuantity]="
              getInBasketQuantity(material.productId, row, column)
            "
            [currentCellValue]="cellsQuantities?.items?.[materialsMatrix?.get(material.productId)?.[row]?.[column]?.productId]?.quantity ?? 0"
            [inventory]="cellData.inventoryObj"
            [isLocked]="material.isLocked && !readonly"
            [readonly]="readonly"
            [sizeRunsCell]="sizerunsGrid"
            data-e2e="grid-cell"
            class="grid-cell position-relative"
            [class.active]="
              isColumnActive(column) || isRowActive(material.productId, row)
            "
            [class.has-value]="quantitiesGroup.get('quantity').value > 0"
            [class.has-bulk]="
              isNowOrder &&
              isCellHasConsignment(material.productId, row, column)
            "
            [class.size-runs-smaller-required]="
              sizerunsGrid &&
              isRequestedMoreThenAvailable(material.productId, row, column)
            "
            [class.in-coords]="isInCoords(column, materialIndex, row)"
            (cellClicked)="selectCell(material.productId, row, column)"
            (cellKeyupEnter)="clearActiveGridCell()"
            (updateTotals)="
              updateTotals({
                materialId: material.productId,
                row: row,
                col: column,
                diff: $event
              })
            "
            (updateTrueDemandTotals)="
              updateTrueDemandTotals({
                materialId: material.productId,
                row: row,
                col: column,
                diff: $event
              })
            "
            (clipboardPasted)="
              onClipboardPaste($event, column, material.productId, row)
            "
            [formControl]="quantitiesGroup.get('quantity')"
          >
            @if (canCopyFromGrid$ | async) {
            <div
              class="drag-handler"
              cdkDrag
              (click)="onClick($event)"
              (cdkDragStarted)="setCopyStartCoords(column, materialIndex, row)"
            ></div>
            } @if (showGridInbound) {
            <ng-container
              [ngTemplateOutlet]="gridCellInbound"
              [ngTemplateOutletContext]="{
                sizeDab: getDabForSize(material.productId, row, column),
                productId: material.productId
              }"
            >
            </ng-container>
            }
          </epc-grid-cell>
          } }
        </div>
        }
      </div>
      <!-- Row Totals -->
      @if (showTotals) {
      <div class="totals p-0 w-100">
        @for ( total of rowTotals()[material.productId]; track row; let row =
        $index) {
        <div
          class="row-total position-relative text-center"
          [class.active]="isRowActive(material.productId, row)"
          [class.locked]="material.isLocked && !readonly"
          [class.d-none]="getRowInventorySum(material.productId, row) === 0"
          (mouseover)="hoverRow(material.productId, row, true)"
          (mouseleave)="hoverRow(material.productId, row, false)"
          data-e2e="row-total"
        >
          @if (isRowDeletable(material.productId, row)) {
          <fa-icon
            size="sm"
            (click)="clearRowQuantities(material.productId, row)"
            [icon]="['fas', 'trash']"
            class="delete-row-icon"
            data-e2e="delete-row-icon"
          ></fa-icon>
          }
          <span [class.opacity-0]="isRowDeletable(material.productId, row)">
            {{ rowTotals()[material.productId][row] }}
            @if (trueDemandRowTotals()[material.productId]?.[row]; as
            trueDemandRowTotal) {
            <div class="absolute-top px-1 font-size-sm">
              <span class="text-success">{{
                rowTotals()[material.productId][row] - trueDemandRowTotal
              }}</span>
              <span class="text-danger">{{ trueDemandRowTotal }}</span>
            </div>
            }
          </span>
          @if (showGridInbound) {
          <ng-container
            [ngTemplateOutlet]="gridCellInbound"
            [ngTemplateOutletContext]="{
              sizeDab: getDabTotalForMaterial(material.productId, row),
              productId: material.productId
            }"
          >
          </ng-container>
          }
        </div>
        }
      </div>
      }
    </div>
    @if (isNowOrder && showInventoryOverview) { @if ( activeCell?.materialId ===
    material?.productId && !material.isLocked ) {
    <div
      class="grid-row inventory-overview position-sticky"
      [style.width]="element.nativeElement.offsetWidth + 'px'"
    >
      <div class="pl-2 d-flex justify-content-end overflow-hidden">
        <epc-inventory-overview
          *ngrxLet="visibleInventoriesLimit$ as limit"
          [showShowMore]="showShowMoreInventories"
          [limitVisibleInventories]="limit"
          class="sticky-right"
          [class.w-100]="!showShowMoreInventories"
        ></epc-inventory-overview>
      </div>
    </div>
    } } }
  </div>
  <!-- Column Totals -->

  @if (showTotals || true) {
  <div
    class="grid-row grid-footer"
    [style.grid-template-columns]="gridColumnsStyle | safeStyle"
  >
    @for (size of xSizes; track index; let index = $index) {

    <div
      class="col-total justify-content-center position-relative"
      [class.active]="isColumnActive(index)"
      data-e2e="col-total"
    >
      <span>{{ colTotals()[index] || 0 }}</span>
      @if (colTotals()[index] && trueDemandColTotals()[index]; as
      trueDemandColTotal) {
      <div class="absolute-top px-1 font-size-sm">
        <span
          class="text-success"
          [atxTooltip]="availableInventoryTooltipLabel"
          >{{ colTotals()[index] - trueDemandColTotal }}</span
        >
        <span
          class="text-danger"
          [atxTooltip]="trueDemandInventoryTooltipLabel"
          >{{ trueDemandColTotal }}</span
        >
      </div>
      }
    </div>
    }
    <span
      data-e2e="product-totals-value"
      class="col-total justify-content-center"
    >
      @if (trueDemandTotals(); as demandTotal) {
      <div class="absolute-top px-1 font-size-sm">
        <span
          class="text-success"
          [atxTooltip]="availableInventoryTooltipLabel"
          [tooltipPlacement]="tooltipPlacement.LEFT"
          >{{ productTotals() - demandTotal }}</span
        >
        <span
          class="text-danger"
          [atxTooltip]="trueDemandInventoryTooltipLabel"
          [tooltipPlacement]="tooltipPlacement.LEFT"
          >{{ demandTotal }}</span
        >
      </div>
      }
      {{ productTotals() }}
    </span>
  </div>
  }
</ng-template>

<ng-template
  #sizeRunAction
  let-material="material"
  let-row="row"
  let-hasPadding="hasPadding"
>
  <ng-container
    *epcFeatureFlag="
      configStripConfigurationKeys.CopySizeRunEnabled;
      namespace: csNameSpace;
      equality: true;
      defaultValue: true
    "
  >
    @if (showSizeRun(material.productId, row)) {
    <fa-icon
      class="size-run-icon"
      [class.p-1]="hasPadding"
      [icon]="getSizeRunIcon(material.productId, row) | async"
      (click)="$event.stopPropagation(); applySizeRun(material.productId, row)"
      data-e2e="apply-size-run"
    ></fa-icon>
    }
  </ng-container>
</ng-template>

<ng-template #gridCellInbound let-sizeDab="sizeDab" let-productId="productId">
  <epc-grid-cell-inbound
    [ngClass]="{
      'grid-cell-inbound-visible': productId === materialInboundToShow,
      'empty-value': !sizeDab
    }"
    data-e2e="grid-cell-inbound"
    class="position-absolute d-flex h-100 w-100 justify-content-center align-items-center grid-cell grid-cell-inbound"
    [displayedQuantity]="sizeDab"
  ></epc-grid-cell-inbound>
</ng-template>
